module.exports = __webpack_public_path__ + "static/img/acerIconia_A3.88db97c2.jpg";